import { forwardRef, type ReactNode } from "react";

interface SectionRevealProps {
  children: ReactNode;
  className?: string;
}

const SectionReveal = forwardRef<HTMLDivElement, SectionRevealProps>(({ children, className = "" }, ref) => (
  <div ref={ref} data-reveal className={className}>
    {children}
  </div>
));

SectionReveal.displayName = "SectionReveal";

export default SectionReveal;
